import React, { useState } from "react";
import "../styles/CommunityPage.css";

const CommunityPage = () => {
  const [searchVisible, setSearchVisible] = useState(false);
  const [questionVisible, setQuestionVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [questionText, setQuestionText] = useState("");

  return (
    <main className="community-container" role="main">
      <header className="community-header">
        <h1>⚠️ community board</h1>
        <p className="tagline"><em> </em></p>
      </header>

      <section className="community-board">
        <div className="community-note">
          <p>
            this is still being developed. what would actually be useful for you?<br /><br />
            drop a note to{" "}
            <a href="mailto:shaq@thecollectorsplatform.com">
              shaq@thecollectorsplatform.com
            </a>{" "}
            with features you’d love to see.
          </p>
        </div>

        <div className="community-action-row">
          <button
            className="community-cta"
            onClick={() => { setQuestionVisible((v) => !v); setSearchVisible(false); }}
            aria-expanded={questionVisible}
          >
            💬 ask the community a question
          </button>
        </div>

        {/* search prototype */}
        {searchVisible && (
          <div className="prototype-box">
            <h3>search</h3>
            <p className="search-hint">coming soon</p>
            <input
              type="text"
              placeholder="search by username or keyword..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        )}

        {/* question prototype */}
        {questionVisible && (
          <div className="prototype-box">
            <h3>submit a question</h3>
            <p className="search-hint">
            coming soon
            </p>
          </div>
        )}
      </section>

      <button
  className="community-back-button"
  onClick={() => (window.location.href = "/#/home-page")}
  aria-label="Go back to home"
>
  ← back to home
</button>

    </main>
  );
};

export default CommunityPage;
